import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddNewProject } from '../Redux/Actions/Projects_Action';
import { Notify } from '../Utility/Notify';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { GetCitiesData } from '../Redux/Actions/CityAction';

export const AddProjectHook = () => {
  const dispatch = useDispatch();
  const [projectname, setProjectName] = useState('');
  const [developername, setDeveloperName] = useState('');
  const [areaname, setAreaName] = useState('');
  const [startprice, setStartPrice] = useState(''); // إضافة state لـ startprice
  const [loading, setloading] = useState(true);
  const [cityname, setcityname] = useState('');
  const [addProjectLoading, setAddProjectLoading] = useState(false);

  //changes state of inpute
  //==================================================================
  const onprojectnamechange = (e) => {
    setProjectName(e.target.value);
  };

  const onchangedevelopername = (e) => {
    setDeveloperName(e.target.value);
  };

  const onchanegAreaName = (e) => {
    setAreaName(e.target.value);
  };

  const onchangecitychange = (e) => {
    setcityname(e.target.value);
  };

  // دالة التغيير الجديدة لـ startprice
  const onStartPriceChange = (e) => {
    const value = e.target.value;
    // التحقق من أن القيمة رقم وليست سلبية
    // if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
    setStartPrice(value);
    // }
  };

  //=================================================================

  //loading developer data
  useEffect(() => {
    const rundevelopers = async () => {
      await dispatch(GetDevelopersData());
    };
    rundevelopers();
  }, [dispatch]);

  const resdevelopersdata = useSelector((state) => state.AllDevelopers.Developers);

  useEffect(() => {
    dispatch(GetCitiesData());
  }, [dispatch]);

  const rescitiesdata = useSelector((state) => state.AllCities.city);

  //=====================================================================================
  //on submit add

  const onsubmitadd = async (e) => {
    e.preventDefault();

    if (projectname === '') {
      Notify('error', 'Please enter project name', 'error');
      return;
    } else if (developername === '') {
      Notify('error', 'Please enter developer name', 'error');
      return;
    } else if (cityname === '') {
      Notify('error', 'Please select city', 'error');
      return;
    } else if (areaname === '') {
      Notify('error', 'Please enter area name', 'error');
      return;
    } else {
      setloading(true);
      setAddProjectLoading(true);

      // تحويل startprice إلى رقم، إذا كان فارغاً نضع 0
      const priceValue = startprice;
      await dispatch(
        AddNewProject({
          name: projectname,
          developer: developername,
          city: cityname,
          area: areaname,
          startprice: priceValue, // إضافة startprice
        }),
      );

      setTimeout(() => {
        window.location.href = '#/Project';
      }, 1500);

      setloading(false);
      setAddProjectLoading(false);
    }
  };

  const resAdd = useSelector((state) => state.AllProjects.Projects);

  useEffect(() => {
    if (loading === false) {
      if (resAdd && resAdd.data) {
        if (resAdd.status === 201) {
          Notify('success', 'Project added successfully', 'success');
          setAreaName('');
          setProjectName('');
          setStartPrice(''); // إعادة تعيين startprice
        }
      }
    }
  }, [loading, resAdd]);

  return [
    projectname,
    developername,
    areaname,
    startprice, // إضافة startprice
    onprojectnamechange,
    onchanegAreaName,
    onchangedevelopername,
    onStartPriceChange, // إضافة الدالة الجديدة
    onsubmitadd,
    resdevelopersdata,
    rescitiesdata,
    onchangecitychange,
    cityname,
    addProjectLoading,
  ];
};
